import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "swiper/swiper-bundle.css";

import "./ClientSwiper.css";
SwiperCore.use([Navigation, Pagination, Autoplay]);
const ClientSwiper = () => {
    const customPrevButton = (
        <IoIosArrowBack size={30} color="#333" className="swiper-button-prev" />
    );

    const customNextButton = (
        <IoIosArrowForward size={30} color="#333" className="swiper-button-next" />
    );

    return (
        <Swiper
            navigation={{
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            }}
            pagination={{ clickable: true }}
            loop
            speed={1000}
            autoplay={{ delay: 1000 }} // Set autoplay delay to 1 second
            className="swiper2 p-8 my-4"
        >
            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "אני לא יכולה להיות יותר ממרוצה מהטיפול המדהים שקיבלתי! אוקסנה הפתיעה אותי במקצועיות, נדיבות וידע. היא הקשיבה לצרכים שלי, המליצה על מוצרים שמתאימים במיוחד לעור שלי, והתוצאה היא פשוט מדהימה! תודה רבה, אני בוודאי אחזור שוב לטיפולים נוספים אצלה."
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    אלכס פוספלוב, ספרית
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "אין לי מילים לתאר כמה אני מרוצה מהטיפול המדהים שלך! הידע שלך בתחום הקוסמטיקה בלתי רגיל, והטיפול שקיבלתי היה פשוט מעולה. הכיף וההנאה שהעברת לי בזמן הטיפול הם לא רק מרגשים, אלא גם מרגשים. אני מודה לך מקרב לב על השירות המדהים, ואני מרגישה חזק כי אני חייבת לחזור שוב בהקדם האפשרי!"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    סבטלנה קוזנצקי, אחות בבית חולים
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' >
                    "Оксана! Спасибо огромное за процедуры, было очень классно, ты большой специалист. Все средства подобраны профессионально, качественно, не было ни аллергии, ни раздражений. Рекомендую!!!"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    ילנה גברילנקו, כוח עזר בית חולים
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' >
                    "Привет , спасибо огромное , даже у такого скептика, просто восторг , никакого раздражения и даже сегодня гладкое как …. младенца."
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    מנהלת חשבונות בחברה, חיפה
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "היי, מה שלומך
                    רציתי להגיד לך תודה על המוצרים
                    השתמשתי בהם היום והעור כבר מרגיש אחרת (אצלי רואים ישר אם אני עושה טוב או רע לעור הפנים  /לגוף )
                    בכל מקרה, תודה רבה
                    והריח של החומצה אזלאית פשוט מהמם 😍
                    והפילינג מהמם 🤩 ישר החליק את עור הפנים"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    נסרין, אם לתינוק
                </p>
            </SwiperSlide>


            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "הי אוקסנה!
                    מאוד מודע לך על הטיפול המדהים💥
                    העור נראה זוהר וקורן, הרגשה מאוד טובה מהעיסוי שלך. התחלתי להשתמש במוצרים לפי המלצה שלך, הכול טוב.
                    סוף שבוע נעים, נפגש שוב לפני החגים🌸"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    אירנה קולומיסקי, תפקיד ניהולי בבית חולים                </p>
            </SwiperSlide>


            <div className="swiper-button-prev-custom">{customPrevButton}</div>
            <div className="swiper-button-next-custom">{customNextButton}</div>
        </Swiper>
    );
}

export default ClientSwiper